let routes = [
	{
		path: '/',
		name: '/',
		component: () => import('@/views/home/home.vue'),
		meta: {
			title: '首页',
			keepAlive: true
		}
	},
    {
        path:'/detail',
        name:'detail',
        component: () => import('@/views/detail/detail.vue'),
		meta: {
			title: '详情页'
		}
    },
	{
        path:'/search',
        name:'search',
        component: () => import('@/views/search/search.vue'),
		meta: {
			title: '搜索',
			keepAlive: true
		}
    },
];

export default routes;